import CloseIcon from "@mui/icons-material/Close";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useEffect } from "react";
import styles from "./Drawer.module.scss";

const Drawer = ({ id, title, children, visible, customCssClass, onClose }) => {
  useEffect(() => {
    if (!visible) return;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [visible]);

  return (
    <div id={id} className={classNames(styles.drawer, !visible && styles.closed, customCssClass)}>
      {title && (
        <section className={styles.title}>
          <h2>{title}</h2>
          {onClose && (
            <button type="button" aria-label="Close" className={styles.closeButton} onClick={onClose}>
              <CloseIcon />
            </button>
          )}
        </section>
      )}

      <section className={classNames(styles.content, title && styles.withTitle)}>{children}</section>
    </div>
  );
};

Drawer.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool.isRequired,
  customCssClass: PropTypes.string,
  onClose: PropTypes.func,
};

export default Drawer;
